<template lang="pug">
  v-flex
    v-menu(
      transition="slide-x-transition"
      bottom
      right
    )  
      template( v-slot:activator="{ on }" )
        v-btn(
          icon
          v-on="on"
        ) 
          v-icon(small :color='obtener_color_de_estado(estado_del_documento)') {{ obtener_icono_de_estado(estado_del_documento) }} 

      v-list
        v-list-item(
          v-for="(item, i) in menu_a_imprimir"
          :key="i"
          @click="item.callback"
        )
          v-list-item-title {{ item.text }}
     
    v-dialog(v-model='ver_formulario_emitir_comprobante' max-width="600px")
      v-card
        v-card-title Emitir comprobante
        v-card-text
          Seccion_comprobante( :modelo = 'modelo' )
        v-card-actions
          v-spacer
          v-btn( block color='primary' @click='emitir_comprobante(id); ver_formulario_emitir_comprobante=false' ) Emitir 
    
    v-dialog(v-model='anulacion_dialog'  max-width="600px")
      v-card
        v-card-title Anular comprobante
        v-card-text
          v-text-field
        v-card-actions
          v-spacer
          v-btn( block outlined color='red' @click='confirmar_anulacion_dialog = true') Eliminar
    
    v-dialog(
      v-model='confirmar_anulacion_dialog'
      max-width="600px"
      persistent
    )
      v-card
        v-card-title ¿Seguro?
        v-card-text
          p ¿Está seguro que desea anular el comprobante?
        v-card-actions
          v-spacer
          v-btn( text  @click='confirmar_anulacion_dialog = false' ) Cancelar
          v-btn( color='red' dark @click='' ) Eliminar

    v-dialog(v-model='ver_formulario_emitir_guia'  max-width="600px")
      v-card
        v-card-title Anular guía
        v-card-text
          Seccion_datos_de_envio( :modelo = 'modelo')
        v-card-actions
          v-spacer
          v-btn( block color='primary' @click='procesar_guia(id); ver_formulario_emitir_guia=false' ) Emitir

    Impresion_salida(:dialog='dialog' @dialog="val=>dialog= val")
</template>
<script>
import {mapActions, mapState} from 'vuex'
export default {
  data: vm => ({
    dialog:false,
    ver_formulario_emitir_comprobante: false,
    ver_formulario_emitir_guia: false,
    menu_original: [
      { text: 'Enviar a almacén', callback: () => vm.procesar({key: vm.id, tipo_de_operacion: 'salida'}), estado_de_visibilidad: ['esperando'] },
      { text: 'Emitir Guía', callback: () => vm.activar_formulario('ver_formulario_emitir_guia'), estado_de_visibilidad: ['procesado'] },   //vm.emitir(vm.id)
      { text: 'Emitir Comprobante', callback: () => vm.activar_formulario('ver_formulario_emitir_comprobante'), estado_de_visibilidad: ['procesado'] },
      //{ text: 'Anular comprobante', callback: () => vm.activar_formulario('anulacion_dialog'), estado_de_visibilidad: ['procesado'] },   
      { text: 'Procesando', callback: () => null , estado_de_visibilidad: ['procesando'] },      
      { text: 'Editar', callback: () => vm.activar_editar(), estado_de_visibilidad: ['esperando']},
      { text: 'Imprimir', callback: () => vm.activar_imprimir(), estado_de_visibilidad: ['procesado', 'emitido'] },
      { text: 'Revertir de almacén', callback: () => vm.procesar({key: vm.id, tipo_de_operacion: 'entrada', es_reversion: true }), estado_de_visibilidad: ['procesado'] },

    ],
    menu_a_imprimir: [],
    anulacion_dialog: false,
    confirmar_anulacion_dialog: false,

  }),
  props:{
    estado_del_documento: String,
    id: String,
    modelo: String,
  },
  watch: {
    'estado_del_documento'(){
      this.filtrar_menu()
    }
  },
  created(){
    this.filtrar_menu()
  },
  methods: {
 
    async procesar_guia(id){
      await this.add()
      this.emitir_guia(id)
    },
    activar_formulario(doc){
      this.get(this.id)
      this[doc] = true 
    },
    activar_editar(){
      this.get(this.id)
      this.Modelo.registerDialog = true
    },
    activar_ver(){
      this.get(this.id)
      this.Modelo.registerDialog = true
    },
    activar_imprimir(){
      this.get(this.id)
      this.dialog = true
    },

    
    ...mapActions({
      procesar: 'Kardex/comprobar_proceso_disponible',
      get: 'Outputs/get',
      add: 'Outputs/add',
      emitir_comprobante: 'Outputs/emitir_comprobante',
      emitir_guia: 'Outputs/emitir_guia',
    }),
    filtrar_menu(){
      this.menu_a_imprimir = this.menu_original.filter(item => item.estado_de_visibilidad.indexOf(this.estado_del_documento) > -1)
    }

  },
  components: {
    Seccion_comprobante: () => import('@/components/componentes/Seccion_comprobante'),
    Seccion_datos_de_envio: () => import('@/components/componentes/Seccion_datos_de_envio'),
    Impresion_salida:()=> import('@/components/impresion_salida')
  },
  computed: {
    Modelo() { return this.$store.state[this.modelo] },
    Datos() { return this.$store.state[this.modelo].data }

  }
}
</script>
